import Vue from 'vue'
import Router from 'vue-router'
import TeacherBam from '@/components/work/teacher/TeacherBam'
import Questionnaire from '@/components/work/teacher/Questionnaire'
import ViewQuestionnaire from '@/components/work/teacher/ViewQuestionnaire'
import TeacherClass from '@/components/work/teacher/TeachClass'
import AccessoryList from '@/components/work/teacher/AccessoryList'
import WriteQuestionnaire from '@/components/work/teacher/WriteQuestionnaire'
import viewWeekTPerformance from '@/components/work/teacher/viewWeekTPerformance'
import viewMonthTPerformance from '@/components/work/teacher/viewMonthTPerformance'

import ReadExcell from '@/components/work/teacher/ReadExcell'
import VieApponintment from '@/components/work/teacher/VieApponintment'
import TeacherEVPI from '@/components/work/teacher/TeacherEVPI'
import IeltsText from '@/components/work/teacher/IeltsText'
import TPerformance from '@/components/work/teacher/TPerformance'
import Kpi from '@/components/work/teacher/Kpi'
import Accessory from '@/components/work/teacher/Accessory'
import ViewSupervise from '@/components/work/teacher/ViewSupervise'
import Supervise from '@/components/work/teacher/Supervise'
import ViewTeahcherLectures from '@/components/work/teacher/ViewTeahcherLectures'
import VieTeacherApponintment from '@/components/work/teacher/VieTeacherApponintment'
import teacherPeport from '@/components/work/teacher/teacherPeport'
import Lectures from '@/components/work/teacher/Lectures'
import ViewTeacherLectures from '@/components/work/leader/ViewTeacherLectures'
import ViewAccessory from '@/components/work/leader/ViewAccessory'
import LeaderIeltsText from '@/components/work/leader/LeaderIeltsText'
import viewPerformance from '@/components/work/leader/viewPerformance'
import viewLPerformance from '@/components/work/leader/viewLPerformance'
import ViewStudentWork from '@/components/work/teacher/ViewStudentWork'
import CloudFile from '@/components/work/teacher/CloudFile'
import PublicCloudFile from '@/components/work/teacher/PublicCloudFile'
import ViewTeacherKpi from '@/components/work/teacher/ViewTeacherKpi'
// import index from '@/components/study/study2/index2'
import app from '@/App'
import InsertWorkModel from '@/components/work/student/InsertWorkModel'
import School from '@/components/study/study3/School'
import students from '@/components/study/study3/students'
import mession from '@/components/study/study3/mession'
import login from '@/components/work/login.vue'
import xjtlu from '@/components/work/XJTLU'
import bam from '@/components/work/bam'
import top from '@/components/work/top'
import Sear from '@/components/work/Sear'
import welcome from '@/components/work/welcome'
import getnews from '@/components/work/getnews'
import NewsAll from '@/components/work/NewsAll'
import ViewAllNews from '@/components/work/ViewAllNews'
import news from '@/components/work/news'
import adminUser from '@/components/work/adminUser'
import { Message } from "element-ui"
import register from '@/components/work/register'
import StudentBam from '@/components/work/student/StudentBam'
import Report from '@/components/work/student/Report'
import EVPI from '@/components/work/student/EVPI'
import CheckEnglish from '@/components/work/student/CheckEnglish'
import ViewIelts from '@/components/work/student/ViewIelts'
import CheckScore from '@/components/work/student/CheckScore'
import AnswerQuestion from '@/components/work/student/AnswerQuestion'
import Apponintment from '@/components/work/student/Apponintment'
import ieltsDeclare from '@/components/work/student/ieltsDeclare'
import IeltsStudentText from '@/components/work/student/IeltsStudentText'
import communications from '@/components/work/navigation/majorsetup/communications'
import ThreeNavigation from '@/components/work/navigation/majorsetup/ThreeNavigation'
import ThreeMenus from '@/components/work/navigation/majorsetup/ThreeMenus'
import file from '@/components/study/study3/student4/file'
import navigation from '@/components/work/bam/navigation'
import OneNavigation from '@/components/work/bam/OneNavigation'
import viewStudentBam from '@/components/work/bam/viewStudentBam'
import Announcement from '@/components/work/bam/Announcement'
import HomePage from '@/components/work/bam/HomePage'
import ShowAnnouncement from '@/components/work/bam/ShowAnnouncement'
import ViewStudentIelts from '@/components/work/bam/ViewStudentIelts'
import leaderBam from '@/components/work/leader/leaderBam'
import ParentBam from '@/components/work/studentParent/ParentBam'
import InstructorBam from '@/components/work/instructor/InstructorBam'
import viewStudentDorm from '@/components/work/instructor/viewStudentDorm'
import ViewKpi from '@/components/work/leader/ViewKpi'
import InstructorPeport from '@/components/work/instructor/InstructorPeport'
import InstructorKpi from '@/components/work/instructor/InstructorKpi'
import LPerformance from '@/components/work/instructor/LPerformance'
import viewAPerformance from '@/components/work/leader/viewAPerformance'
import viewPPerformance from '@/components/work/leader/viewPPerformance'

import viewMonthIPerformance from '@/components/work/instructor/viewMonthIPerformance'
import viewWeekIPerformance from '@/components/work/instructor/viewWeekIPerformance'
import InstrutorEVPI from '@/components/work/instructor/InstrutorEVPI'
import ViewStudentInfo from '@/components/work/instructor/ViewStudentInfo'
import FourNavigation from '@/components/work/navigation/majorsetup/FourNavigation'
import InfoFour from '@/components/work/navigation/majorsetup/InfoFour'
import FourCommunication from '@/components/work/navigation/majorsetup/FourCommunication'
import CheckRoom from '@/components/work/student/CheckRoom'
import AdministrativeBam from '@/components/work/administrative/administrativeBam'

import LoginUserList from '@/components/work/administrative/LoginUserList'
import viewMonthAPerformance from '@/components/work/administrative/viewMonthAPerformance'
import viewWeekAPerformance from '@/components/work/administrative/viewWeekAPerformance'
import APerformance from '@/components/work/administrative/APerformance'

import ProfessionalTeacherBam from '@/components/work/professionalTeacher/ProfessionalTeacherBam'
import Pperformance from '@/components/work/professionalTeacher/Pperformance'
import viewMonthPPerformance from '@/components/work/professionalTeacher/viewMonthPPerformance'
import viewWeekPPerformance from '@/components/work/professionalTeacher/viewWeekPPerformance'

Vue.use(Router)
const router= new Router({
  routes: [
    {
      path: '/login',
      name:'Login',
      component:login
      //component: ()=> import('@/components/study/study3/login')
      
    }, {
      path: '/file',
      name:'file',
      component:file
      //component: ()=> import('@/components/study/study3/login')
      
    },{
      path:'/register',
      name:'register',
      component:register
    },
    {path:'/TeacherBam',name:'TeacherBam',component:TeacherBam,meta:{isAuthTer:true},
     children:[
    {path:'/ViewStudentWork',
     name:'ViewStudentWork',
     component:ViewStudentWork,meta:{isAuthTer:true}
    },
    {path:'/ReadExcell',
    name:'ReadExcell',
    component:ReadExcell,meta:{isAuthTer:true}
   },
   {path:'/teacherPeport',name:'teacherPeport',component:teacherPeport,meta:{isAuthTer:true}},
   {path:'/TeacherEVPI',name:'TeacherEVPI',component:TeacherEVPI,meta:{isAuthTer:true}},
   {path:'/TeacherClass',name:'TeacherClass',component:TeacherClass,meta:{isAuthTer:true}},
   {path:'/Lectures',name:'Lectures',component:Lectures,meta:{isAuthTer:true}},
   {path:'/ViewTeahcherLectures',name:'ViewTeahcherLectures',component:ViewTeahcherLectures,meta:{isAuthTer:true}},
   {path:'/VieApponintment',name:'VieApponintment',component:VieApponintment,meta:{isAuthTer:true}},
   {path:'/VieTeacherApponintment',name:'VieTeacherApponintment',component:VieTeacherApponintment,meta:{isAuthTer:true}},
   {path:'/Accessory',name:'Accessory',component:Accessory,meta:{isAuthTer:true}},
   {path:'/asViewStudentIelts',component:ViewStudentIelts,meta:{isAuthTer:true}},
   {path:'/Supervise',name:'Supervise',component:Supervise,meta:{isAuthTer:true}},
   {path:'/IeltsText',component:IeltsText,meta:{isAuthTer:true}},
   {path:'/ViewSupervise',component:ViewSupervise,meta:{isAuthTer:true}},
   {path:'/Kpi',component:Kpi,meta:{isAuthTer:true}},
   {path:'/CloudFile',component:CloudFile,meta:{isAuthTer:true}},
   {path:'/PublicCloudFile',component:PublicCloudFile,meta:{isAuthTer:true}},
   {path:'/ViewTeacherKpi',component:ViewTeacherKpi,meta:{isAuthTer:true}},
   {path:'/Questionnaire',component:Questionnaire,meta:{isAuthTer:true}},
   {path:'/ViewQuestionnaire',component:ViewQuestionnaire,meta:{isAuthTer:true}},
   {path:'/teacherAnswerQuestion',name:'teacherAnswerQuestion',component:WriteQuestionnaire,meta:{isAuthTer:true}}, 
   {path:'/teacherPerformance',name:'TPerformance',component:TPerformance,meta:{isAuthTer:true}}, 
   {path:'/viewWeekTPerformance',name:'viewWeekTPerformance',component:viewWeekTPerformance,meta:{isAuthTer:true}},
   {path:'/viewMonthTPerformance',name:'viewMonthTPerformance',component:viewMonthTPerformance,meta:{isAuthTer:true}},
  ]
  },
    {
      path:'/StudentBam',
      name:'StudentBam',
      component:StudentBam,
      meta:{isAuthStudent:true},
      children:[
        {path:'/Report',name:'Report',component:Report,meta:{isAuthStudent:true}}, 
        {path:'/EVPI',name:'EVPI',component:EVPI,meta:{isAuthStudent:true}}, 
        {path:'/ieltsDeclare',name:'ieltsDeclare',component:ieltsDeclare,meta:{isAuthStudent:true}}, 
        {path:'/ViewIelts',name:'ViewIelts',component:ViewIelts,meta:{isAuthStudent:true}}, 
        {path:'/CheckScore',name:'CheckScore',component:CheckScore,meta:{isAuthStudent:true}}, 
        {path:'/CheckEnglish',name:'CheckScore',component:CheckEnglish,meta:{isAuthStudent:true}}, 
        {path:'/Apponintment',name:'Apponintment',component:Apponintment,meta:{isAuthStudent:true}}, 
        {path:'/IeltsStudentText',name:'IeltsStudentText',component:IeltsStudentText,meta:{isAuthStudent:true}}, 
        {path:'/CheckRoom',name:'CheckRoom',component:CheckRoom,meta:{isAuthStudent:true}}, 
        {path:'/studentAnswerQuestion',name:'answerQuestion',component:WriteQuestionnaire,meta:{isAuthStudent:true}}, 
      ]
    },
    {
      path:'/professionalTeacherBam',
      name:'professionalTeacherBam',
      component:ProfessionalTeacherBam,
      meta:{ProfessionalTeacher:true},
      children:[
        {path:'/pPerformance',name:'pPerformance',component:Pperformance,meta:{ProfessionalTeacher:true}}, 
        {path:'/viewMonthPPerformance',name:'viewMonthPPerformance',component:viewMonthPPerformance,meta:{ProfessionalTeacher:true}}, 
        {path:'/viewWeekPPerformance',name:'viewWeekPPerformance',component:viewWeekPPerformance,meta:{ProfessionalTeacher:true}}, 
      ]
    },
    {
      path:'/administrativeBam',
      name:'administrativeBam',
      component:AdministrativeBam,
      meta:{isAuthAdministrative:true},
      children:[
        {path:'/aPerformance',name:'aPerformance',component:APerformance,meta:{isAuthAdministrative:true}}, 
        {path:'/viewMonthAPerformance',name:'viewMonthAPerformance',component:viewMonthAPerformance,meta:{isAuthAdministrative:true}}, 
        {path:'/viewWeekAPerformance',name:'viewWeekAPerformance',component:viewWeekAPerformance,meta:{isAuthAdministrative:true}}, 
      ]
    },
    {  path:'/ParentBam',
       name:'ParentBam',
       component:ParentBam, 
       children:[
        {path:'/ParentReport',name:'Report',component:Report}, 
        {path:'/ParentViewIelts',name:'ViewIelts',component:ViewIelts}, 
        {path:'/ParentCheckScore',name:'CheckScore',component:CheckScore,}, 
        {path:'/ParentCheckEnglish',name:'CheckScore',component:CheckEnglish,}, 
       ]
    },
    
    
    {
      path:'/leaderBam',
      name:'leaderBam',
      component:leaderBam,
      meta:{isAuthLeader:true},
      children:[
        {path:'/leadergetnews',component:getnews, meta:{isAuthLeader:true}},
        {path:'/ViewStudentIelts',component:ViewStudentIelts,meta:{isAuthLeader:true}},
        {path:'/ViewTeacherWork',name:'ViewTeacherWork',component:ViewStudentWork,meta:{isAuthLeader:true}},
        {path:'/ViewTeacherLectures',name:'ViewTeacherLectures',component:ViewTeacherLectures,meta:{isAuthLeader:true}},
        {path:'/ViewAccessory',name:'ViewAccessory',component:ViewAccessory,meta:{isAuthLeader:true}},
        {path:'/asLectures',name:'asLectures',component:Lectures,meta:{isAuthLeader:true}},
        {path:'/asViewTeahcherLectures',name:'asViewTeahcherLectures',component:ViewTeahcherLectures,meta:{isAuthLeader:true}},
        {path:'/asteacherPeport',name:'asteacherPeport',component:teacherPeport,meta:{isAuthLeader:true}},
        {path:'/LeaderIeltsText',name:'LeaderIeltsText',component:LeaderIeltsText,meta:{isAuthLeader:true}},
        {path:'/LeaderSupervise',name:'LeaderSupervise',component:Supervise,meta:{isAuthLeader:true}},
        {path:'/LeaderViewSupervise',component:ViewSupervise,meta:{isAuthLeader:true}},
        {path:'/ViewKpi',component:ViewKpi,meta:{isAuthLeader:true}},
        {path:'/leaderKpi',component:Kpi,meta:{isAuthLeader:true}},
        {path:'/LeaderCloudFile',component:CloudFile,meta:{isAuthLeader:true}},
        {path:'/LeaderPublicCloudFile',component:PublicCloudFile,meta:{isAuthLeader:true}},
        {path:'/leaderQuestionnaire',component:Questionnaire,meta:{isAuthLeader:true}},
         {path:'/leaderViewQuestionnaire',component:ViewQuestionnaire,meta:{isAuthLeader:true}},
         {path:'/ealderAnswerQuestion',name:'ealderAnswerQuestion',component:WriteQuestionnaire,meta:{isAuthLeader:true}}, 
         {path:'/viewPerformance',name:'viewPerformance',component:viewPerformance,meta:{isAuthLeader:true}}, 
         {path:'/viewLPerformance',name:'viewLPerformance',component:viewLPerformance,meta:{isAuthLeader:true}}, 
         {path:'/viewAPerformance',name:'viewAPerformance',component:viewAPerformance,meta:{isAuthLeader:true}}, 
         {path:'/viewPPerformance',name:'viewPPerformance',component:viewPPerformance,meta:{isAuthLeader:true}}, 
      ]
    },
    {path:'/InstructorBam',
    name:'InstructorBam',
    component:InstructorBam,
    children:[
      {path:'/InstructorPeport',component:InstructorPeport, meta:{isAuthInstructor:true}},
      {path:'/InstrutorEVPI',component:InstrutorEVPI, meta:{isAuthInstructor:true}},
      {path:'/VieApponintments',name:'VieApponintments',component:VieApponintment,meta:{isAuthInstructor:true}},
      {path:'/ViewStudentInfo',component:ViewStudentInfo, meta:{isAuthInstructor:true}},
      {path:'/VieTeacherApponintments',name:'VieTeacherApponintments',component:VieTeacherApponintment, meta:{isAuthInstructor:true}},
      {path:'/InstructorSupervise',name:'InstructorSupervise',component:Supervise,meta:{isAuthInstructor:true}},
      {path:'/InstructorViewSupervise',component:ViewSupervise,meta:{isAuthInstructor:true}},
      {path:'/viewStudentDorm',component:viewStudentDorm,meta:{isAuthInstructor:true}},
      {path:'/InstructorKpi',component:InstructorKpi,meta:{isAuthInstructor:true}},
      {path:'/ViewInstructorKpi',component:ViewTeacherKpi,meta:{isAuthInstructor:true}},
      {path:'/InstructorCloudFile',component:CloudFile,meta:{isAuthInstructor:true}},
      {path:'/InstructorPublicCloudFile',component:PublicCloudFile,meta:{isAuthInstructor:true}},
      {path:'/instructorPerformance',component:LPerformance,meta:{isAuthInstructor:true}},
      {path:'/viewMonthIPerformance',component:viewMonthIPerformance,meta:{isAuthInstructor:true}},
      {path:'/viewWeekIPerformance',component:viewWeekIPerformance,meta:{isAuthInstructor:true}},
    ]},
    {
      path: '/',
      component:top,
      redirect:"/text", 
      children:[
        {path:'/text',component:xjtlu}, 
        {path:'/NewsAll',component:NewsAll}, 
        {path:'/ViewAllNews',component:ViewAllNews}, 
        {path:'/news/',name:'news',component:news},
        {path:'/FourCommunication',name:'FourCommunication',component:FourCommunication},
        {path: '/InfoFour',name:'InfoFour',component:InfoFour},
        {path:'/communications',name:'communications',component:communications},
        {path:'/ThreeMenus',name:'ThreeMenus',component:ThreeMenus},
        {path:'/ShowAnnouncement',name:'ShowAnnouncement',component:ShowAnnouncement},
        {path:'/AccessoryList',name:'AccessoryList',component:AccessoryList},
        {path:'/Sear',name:'Sear',component:Sear},
      ]
    },
    {
      path: '/bam',
      name:'bam',
      component:bam,
      redirect:"/welcome", 
      meta:{isAuth:true},
      children:[
        {path:'/welcome',component:welcome,meta:{isAuth:true}},
        {path:'/getnews',component:getnews,meta:{isAuth:true},},
        {path:'/HomePage',component:HomePage,meta:{isAuth:true},},
        {path:'/adminUser',component:adminUser,meta:{isAuth:true}},
        {path:'/navigation',component:navigation,meta:{isAuth:true}},
        {path:'/ThreeNavigation',name:'ThreeNavigation',component:ThreeNavigation,meta:{isAuth:true}},
        {path:'/OneNavigation',name:'OneNavigation',component:OneNavigation,meta:{isAuth:true}},
        {path:'/viewStudentBam',name:'viewStudentBam',component:viewStudentBam,meta:{isAuth:true}},
        {path:'/Announcement',name:'Announcement',component:Announcement,meta:{isAuth:true}},
        {path:'/FourNavigation',name:'FourNavigation',component:FourNavigation,meta:{isAuth:true}},
        {path:'/LoginUserList',name:'LoginUserList',component:LoginUserList,meta:{isAuth:true}}, 

      
      ]
    },
    {
      path: '/home',
     
      component: app
    },
    {
      path:"/InsertWorkModel",
      name:'InsertWorkModel',
      component:InsertWorkModel
    },
    {
      path: '/text',
      component: xjtlu
    },

    // {
    //   name:'school',
    //   path: '/School',
    //   component: School,
    //   children:[{
    //     path: 'login',
    //     component: index,
    //     children:[{
    //       name:'mession',
    //       path: 'mession/:id/:title',
    //       component: mession,
    //       props:true
    

    //     }]
    //   }
    //   ]
    // },

    {
      path:'/students',
      component:students
    },
    {
      path:'/NewsAll',
      component:NewsAll
    },

  
  ]
})




router.beforeEach((to,from,next)=>{
let vm=new Vue()
console.log(vm.$user)

  if(to.meta.isAuth){
     if(authority()){
      if(JSON.parse(localStorage.getItem('user')).type===2){
        next()
      }else{
        Message({message: "无权限",type: "success"});
      } 
     } 
  }else if(to.meta.isAuthTer){
      if(authority()){
      if(JSON.parse(localStorage.getItem('user')).type===0){  
    if(JSON.parse(localStorage.getItem('user')).authentication==false&to.name!='TeacherEVPI'){
      Message({message: "此用户暂时未被认证，请联系管理员认证",type: "success"})
       router.push({name: 'TeacherEVPI'});   
       return false 
    }else{
      next()
    }
        }else{
          Message({message: "无权限",type: "success"});
      }  
      }
  }else if(to.meta.isAuthStudent){
    if(authority()){
      if(JSON.parse(localStorage.getItem('user')).type===1||JSON.parse(localStorage.getItem('user')).type==3){
        let studentId=JSON.parse(localStorage.getItem('user')).studentID
        if((studentId=='' || studentId==null)&to.name!='EVPI' ){
          Message({message: "请先完善个人信息",type: "success"})
          router.push({name: 'EVPI'});   
          return false 
        }
        next()
      }else{
        Message({message: "无权限",type: "success"});
    }  
    }
}else if(to.meta.isAuthLeader){
  if(authority()){
    if(JSON.parse(localStorage.getItem('user')).type===4){
      next()
    }else{
      Message({message: "无权限",type: "success"});
  }  
  }
}else if(to.meta.isAuthInstructor){        
  if(authority()){
    if(JSON.parse(localStorage.getItem('user')).type===5||JSON.parse(localStorage.getItem('user')).type==5){

     if(JSON.parse(localStorage.getItem('user')).authentication==false&to.name!='InstructorBam'){
      Message({message: "此用户暂时未被认证，请联系管理员认证",type: "success"})
       router.push({name: 'InstructorBam'});   
       return false 
    }else{
      next()
    }
    }else{
      Message({message: "无权限",type: "success"});
  }  
  }
} else if(to.meta.isAuthAdministrative){
  if(authority()){
   if(JSON.parse(localStorage.getItem('user')).type===6){
     next()
   }else{
     Message({message: "无权限",type: "success"});
   } 
  } 
}else if(to.meta.ProfessionalTeacher){
  if(authority()){
   if(JSON.parse(localStorage.getItem('user')).type===7){
     next()
   }else{
     Message({message: "无权限",type: "success"});
   } 
  } 
}else{
    next()
  }
})
function authority(){
  if(localStorage.getItem('user')===''||localStorage.getItem('user')===null){
    Message({
      message: "请登录！",
      type: "success"
    });
    router.push({name: 'Login'});    
    return false
  }else{
    return true
  }
}

// function Authentication2(){
//     let Authentications=JSON.parse(localStorage.getItem('user')).authentication
//     if((Authentications=='' || Authentications==false)){
//       Message({message: "此用户暂时未被认证，请联系管理员认证",type: "success"})
//       router.push({name: 'TeacherEVPI'});   
//       return false 
//     }else{
//       return true
//     }
// }
// 路由重复不报错
const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router




// WEBPACK FOOTER //
// ./src/router/index.js